Vue.component('discount-bar', {
	template: '#vue-discount-bar',
	props: {
		dType: { default: 'po' },
		dPercent: { default: '' }
	}
});

Vue.component('discount-name', {
	template: '#vue-discount-name',
	props: {
		discountType: { default: 'po' },
		discountName: { default: '' },
		discountPercentage: { default: 0 }

	},
	data: function () {
		return {
			classPromocja: ''
		}
	},
	created: function () {
		const self = this;

		if (!self.classPromocja && self.discountType) {
			self.classPromocja = 'bg-promocja-' + self.discountType;
		}
	}
});